import { connect } from 'react-redux'
import {
  getUsers,
  resetPropsResendEmail,
} from 'reduxpath/ducks/User/List'

import List from './units'

const mapStateToProps = state => ({
  user: state.UserList,
  data: state.UserList.data,
  isLoading: state.UserList.isLoading,
  selectedCountry: state.Reference.selectedCountry,
  isSend: state.UserList.isSend,
  isSendError: state.UserList.isSendError,
})

const mapDispatchToProps = dispatch => ({
  handlePageChange(emailFilter, countryFilter) {
    return (key) => {
      const limit = 10
      const qs = {
        skip: key.selected * limit,
        where: {
          or: [
            { hasAgreedTnc: true },
            { source: { '!': 'admin' } },
          ],
          source: { '!': 'getcraft' },
        },
      }

      if (emailFilter) {
        qs.where.email = `${emailFilter}%`
      }

      if (countryFilter) {
        qs.where.country = countryFilter
      }

      dispatch(getUsers(qs))
    }
  },

  resetProps() {
    dispatch(resetPropsResendEmail())
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(List)
